import { ApiRequestInterceptor } from "./apiRequest";
import { NOSOTROS } from "../constants/endpoints/endpoints";

export const fetchNosotros = async () => {
    const method = "GET";
    const response = await ApiRequestInterceptor(NOSOTROS.nosotros, method);
    const { code, data } = response;

    if (code === 200) {
        return { code, data };
    } else {
        throw new Error("Error al obtener datos de nosotros");
    }
};
